<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JVhQga/tc-custom/9781644030486.jpg?1734695542323" alt="This image is the cover for the book Jump Into Wool Appliqué"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jump Into Wool Appliqué
      </h1>
      <p class="bookDescription body article font2">
        <p>Learn the art of wool appliqué Beginners rejoice—getting started with wool appliqué has never been easier! This project-based introductory guide will give you everything you need to know to explore and enjoy a fun, hands-on fiber art. Stitch six cute flora-and-fauna-themed projects onto sewing accessories, bags, wallhangings, pillows, and more. Each project includes an embroidery embellishment for extra inspiration. While this book is ideal for beginners, the adorable designs are still perfect and enjoyable for all sewists!   Wool appliqué beginners delve into 6 versatile projects with step-by-step instructions Includes comprehensive information on tools needed plus endless tips and tricks The second book in our “Jump into” series—explore a fun, new, and relaxing fiber art technique!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carrie J. Buck
      </h2>
      
      <p class="authorDescription body article">Carrie Buck graduated from Ohio University with a degree in studio arts, concentrating in ceramics, drawing, and fiber. In 2006, she began selling wool appliqué purses and tote bags made from wool she dyed. Soon after, she began marketing her designs as patterns for others to create. Carrie currently resides in Medina County, Ohio, with two cats and one old bunny. carriedawaydesigns.net</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Published by C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5351462f